document.addEventListener('DOMContentLoaded', function () {

    new Swiper('.jouby_slider', {
      slidesPerView: 3,
      spaceBetween: 0,
      loop: true,
      centeredSlides: true,
      initialSlide: 3,
      navigation: {
        nextEl: '.swiper-button-next',
        prevEl: '.swiper-button-prev',
      },

      breakpoints: {
        0: {
          slidesPerView: 1
        },
        768: {
          slidesPerView: 2
        },
        992: {
          slidesPerView: 3
        }
      }
    });

  });
  